export class PagedResult<T> {
    items: T[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;

    constructor(items: T[], totalCount: number, pageNumber: number, pageSize: number) {
        this.items = items;
        this.totalCount = totalCount;
        this.pageNumber = pageNumber;
        this.pageSize = pageSize;
    }
}
